import { Component, OnInit, AfterContentInit, Optional, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  TenderV2DTO, TenderEnvelopeDocumentDTO, TenderAdmissionStatusCodeDTO,
  TaskDTO, TenderStateDTOV2, TenderStateDTO, TenderDTO, TenderLot, TenderLotV2DTO, TenderLotState, FileDetailsDTO,
  SignatureDTO, TriStateDTO
} from '../../api/plyca-dtos';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import {
  ProcurementProjectDTO,
  EnvelopeDTO,
  ProcurementProjectLotDTO
} from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { ActivatedRoute } from '@angular/router';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { finalize, catchError, take, switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, throwError, concat } from 'rxjs';
import { TenderEnvelopedDocumentEditorComponent } from './tenderEnvelopedDocumentEditor.component';
import { DocumentService } from '../../documents/document.service';
import { HelpType, HelpService } from '../../components/common/help/help.service';
import * as lodash from 'lodash';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { ConfirmationService } from 'primeng-lts/api';

@Component({
  selector: 'tenderDocuments',
  templateUrl: 'tenderDocuments.template.html',
  providers: [DialogService, UIService]
})
export class TenderDocumentsComponent extends BaseComponent implements OnInit, AfterContentInit, OnDestroy {
  loaded = false;

  editMode: boolean;
  public TenderStateDTOV2 = TenderStateDTOV2;
  public TenderAdmissionStatusCodeDTO = TenderAdmissionStatusCodeDTO;
  public TriStateDTO = TriStateDTO;
  public hasLots = false;

  identifier: string;
  tender: TenderV2DTO;
  envelopes: string[];
  tagsParent: string[];
  // INFORMACION DEL EXPEDIENTE
  project: ProcurementProjectDTO;
  tenderingEnvelopes: Array<EnvelopeDTO>;
  tenderDocs: Array<TenderEnvelopeDocumentDTO>;
  windowHash: any;
  task: TaskDTO;
  public stateChangeEnabled = false;
  public enableRejectOnRegister = false;
  // variables estado lotes
  public lotsColHeaders: string[];
  public tenderLotStates: any[];
  public tenderLotStatesWithInitial: any[];
  public yesNoModel: any;
  private editingLots: Map<string, TenderLotV2DTO>;
  public selectedTab: number;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    protected configuration: Configuration,
    public translationService: TranslateService,
    private headerActionsService: HeaderActionsService,
    protected waitService: WaitLoadingService,
    protected dialogService: DialogService,
    protected helpService: HelpService,
    protected documentService: DocumentService,
    protected translateService: TranslateService,
    private confirmationService: ConfirmationService,
    @Optional() private dialogConfig: DynamicDialogConfig,
    @Optional() public ref: DynamicDialogRef,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super();

    this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => this.tagsParent = helpTags)).subscribe();


    if (dialogConfig && dialogConfig.data) {
      this.identifier = dialogConfig.data.id;
      this.editMode = dialogConfig.data.editMode;
      this.task = dialogConfig.data.task;
      this.project = dialogConfig.data.project;
      this.hasLots = this.project.breakdownLot.apportioned;
      this.envelopes = this.task?.work?.context?.configurations?.enabledTenderEnvelopes?.value
      this.stateChangeEnabled = this.task.work.context && this.task.work.context.configurations
        && this.task.work.context.configurations.modeEvaluateTendersEnabled
        && this.task.work.context.configurations.modeEvaluateTendersEnabled.value;
      this.enableRejectOnRegister = this.task.work.context && this.task.work.context.configurations
        && this.task.work.context.configurations.enableRejectOnRegister
        && this.task.work.context.configurations.enableRejectOnRegister.value;


    }
    this.lotsColHeaders = ['TenderEvaluation.lots.lot', 'General.state'
      , 'TenderEvaluation.lots.motivationState', 'TenderLotState.abnormal'];
    this.tenderLotStatesWithInitial = [
      { label: this.translateService.instant('TenderLotState.INITIAL'), value: TenderAdmissionStatusCodeDTO.INITIAL },
      { label: this.translateService.instant('TenderLotState.ADMITTED'), value: TenderAdmissionStatusCodeDTO.ACEPTED },
      { label: this.translateService.instant('TenderLotState.REJECTED'), value: TenderAdmissionStatusCodeDTO.REFUSED },
      { label: this.translateService.instant('TenderLotState.EXCLUDED'), value: TenderAdmissionStatusCodeDTO.EXCLUDED }
    ];
    this.tenderLotStates = [
      { label: this.translateService.instant('TenderLotState.ADMITTED'), value: TenderAdmissionStatusCodeDTO.ACEPTED },
      { label: this.translateService.instant('TenderLotState.REJECTED'), value: TenderAdmissionStatusCodeDTO.REFUSED },
      { label: this.translateService.instant('TenderLotState.EXCLUDED'), value: TenderAdmissionStatusCodeDTO.EXCLUDED }
    ];
    this.yesNoModel = [
      { label: this.translateService.instant('General.undefined'), value: TriStateDTO.UNDEFINED },
      { label: this.translateService.instant('General.yes'), value: TriStateDTO.YES },
      { label: this.translateService.instant('General.no'), value: TriStateDTO.NO }
    ];
    this.editingLots = new Map<string, TenderLotV2DTO>();
    this.editMode = true;
  }


  ngOnInit(): void {
    this.waitService.startWaiting();
    let envelopes = this.task?.work?.context?.configurations?.enabledTenderEnvelopes?.value;
    if (envelopes) {
      let migrationURL = this.configuration.TENDER_ACTION_MIGRATEDOCUMENTS_URL.replace('<tenderId>', this.identifier) + envelopes;
      this.subscribe(this.plycaService.insert<any>(migrationURL, {}), () => {
        this.loadTenderDocuments();
      },
        (error) => {
          console.log(error);
          this.ref.close();
        });
    } else {
      this.loadTenderDocuments();
    }
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {

        this.headerActionsService.clearWindowActions(this.windowHash);
        this.dialogService = null;
        this.ref = null;
        this.dialogConfig = null;
        super.ngOnDestroy();
      })));
  }

  loadTenderDocuments() {
    this.subscribe(
      this.plycaService.get<TenderV2DTO>(
        this.configuration.TENDER_SERVICE_V2_URL,
        this.identifier
      )
        .pipe(
          finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
        ),
      (result: TenderV2DTO) => {
        this.tender = result;
        if (result.tenderEnvelopeDocuments) {
          console.log('DOCUMENTOS RECUPERADOS: ' + result.tenderEnvelopeDocuments);
          this.tenderDocs = result.tenderEnvelopeDocuments;
        } else {
          console.log('NO SE HAN RECUPERADO DOCUMENTOS');
          this.tenderDocs = [];
        }
        this.clasifyDocs();
      });
  }

  /**
   * Metodo de clasifica los documentos en los sobres a los que pertenece
   */
  clasifyDocs() {

    let tenderingEnvelopes = [] as Array<EnvelopeDTO>; // TenderEnvelopeDTO¿?

    this.tenderDocs.forEach(doc => {
      if (doc.envelope) {
        let envelope = tenderingEnvelopes.find(_envelope => _envelope.identifier === doc.envelope.identifier);
        if (!envelope) {
          // hace falta?
          envelope = lodash.cloneDeep(doc.envelope);
          tenderingEnvelopes.push(envelope);
        }
        if (!envelope['_files']) {
          envelope['_files'] = [];
        }
        envelope['_files'].push(doc);
      }
    });
    tenderingEnvelopes.sort((env1, env2) => env1.order - env2.order);
    this.tenderingEnvelopes = tenderingEnvelopes;
  }

  public isEnvelopeEditable(envelopeToTest: EnvelopeDTO): boolean {
    return this.editMode && (!this.envelopes || this.envelopes.length === 0
      || this.envelopes.find((envIdentifier: string) => envelopeToTest?.identifier === envIdentifier) !== undefined);
  }

  isLoaded() {
    return this.loaded;
  }

  ngAfterContentInit(): void {

    this.subscribe(this.helpService.showContextHelpObservable(HelpType.ELEC_DOC_RECEIVED));
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (this.hasLots) {
      this.headerActionsService.addActionGroup(
        'lots.actions',
        this.translateService.instant('TendeDocuments.Lots.Actions'),
        'fas fa-cog',
        'btn-secondary',
        true,
        this.windowHash,
        () => this.hasInitialStateLots()
      );
      this.subscribe(this.headerActionsService.addActionToGroup(
        'lots.actions',
        this.translateService.instant('TendeDocuments.Lots.Accept'),
        'far fa-thumbs-up text-success',
        'btn-secondary',
        true,
        this.windowHash,
        () => this.hasInitialStateLots()),
        () => this.acceptAllLots()
      );
      this.subscribe(this.headerActionsService.addActionToGroup(
        'lots.actions',
        this.translateService.instant('TendeDocuments.Lots.Reject'),
        'far fa-thumbs-down text-danger',
        'btn-secondary',
        true,
        this.windowHash,
        () => this.hasInitialStateLots()),
        () => this.rejectAllLots()
      );
      this.subscribe(this.headerActionsService.addActionToGroup(
        'lots.actions',
        this.translateService.instant('TendeDocuments.Lots.Exclude'),
        'far fa-thumbs-down',
        'btn-secondary',
        true,
        this.windowHash,
        () => this.hasInitialStateLots()),
        () => this.excludeAllLots()
      );
      this.headerActionsService.addWindowDivider(this.windowHash);
    }
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => {
        this.ref.close(this.tender);
      });
  }

  private hasInitialStateLots(): boolean {
    return this.tender.tenderLots?.
      filter((lot: TenderLotV2DTO) => lot?.tenderEvaluation?.admissionStatus?.statusCode === TenderAdmissionStatusCodeDTO.INITIAL)?.
      length > 0
  }

  editDocument(doc: TenderEnvelopeDocumentDTO) {
    console.log('Editando fila: ', doc);
    if (this.editMode) {
      this.openDocumentEditor(doc, doc.envelope);
    }
  }

  addDocument(envelope: EnvelopeDTO) {
    console.log('Add document en sobre: ', envelope);
    if (this.editMode) {
      console.log('Nueva fila');
      this.openDocumentEditor(undefined, envelope);
    }
  }

  openDocumentEditor(doc: TenderEnvelopeDocumentDTO, envelope: EnvelopeDTO) {
    let config: DynamicDialogConfig = {
      header: 'Editar documento de la oferta',
      width: '50%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    if (doc) {
      config['identifier'] = doc.identifier;
    }
    config['tender'] = this.tender;
    config['tenderEnvelope'] = envelope;
    const dialog = this.dialogService.open(TenderEnvelopedDocumentEditorComponent, config);
    dialog.onClose.pipe(take(1)).subscribe(result => {
      this.loadTenderDocuments();
    });
  }

  viewDocument(doc: TenderEnvelopeDocumentDTO) {
    this.documentService.viewFile(doc.documentFile, [HelpType.VER_DOC_PRESENTADA]);
  }

  downloadDocument(doc: TenderEnvelopeDocumentDTO) {
    this.documentService.downloadEmbedded(doc.documentFile);
  }

  public deleteDocument(doc: TenderEnvelopeDocumentDTO, envelope: EnvelopeDTO) {
    this.confirmationService.confirm({
      message: this.translateService.instant('General.confirm.action.delete'),
      accept: () => {
        this.subscribe(this.plycaService.delete(this.configuration.TENDERENVELOPEDOCUMENT_V1_SERVICE_URL, doc.identifier).pipe(
          tap(() => {
            envelope['_files'] = envelope['_files'].filter((file) => file.identifier !== doc.identifier);
          }),
          catchError((error: any) => {
            console.error('Error al borrar documento', doc, error);
            this.uiService.showMessage(this.translateService.instant('ProcedureCircuit.Error.DeleteDoc'));
            return throwError(error);
          })
        ));
      }
    });
  }

  // Metodos de gestion de estados a implementar
  public acceptTenderState(tender: TenderV2DTO): void {
    this.subscribe(this.patchTenderState(tender.identifier, TenderStateDTO.ACCEPTED),
      () => this.ref.close(tender));
  }

  public rejectTenderState(tender: TenderV2DTO): void {
    this.subscribe(this.patchTenderState(tender.identifier, TenderStateDTO.REJECTED),
      () => this.ref.close(tender));
  }

  public changeTenderState(tender: TenderV2DTO): void {
    if (tender.document && tender.document.currentState && tender.document.currentState.identifier === TenderStateDTOV2.ACCEPTED) {
      this.rejectTenderState(tender);
    } else {
      this.acceptTenderState(tender);
    }
  }

  signatures(fileDetails: FileDetailsDTO): Array<SignatureDTO> {
    return SignatureDTO.getSignatures(fileDetails);
  }

  public lowTender(value: TriStateDTO, tender: TenderV2DTO): void {
    let tenderLot = tender.tenderLots[0];
    const tendereval = tenderLot.tenderEvaluation;
    tendereval.isConsideredAsAbnormallyLowTender = value;
    let patchedTenderLot = new TenderLot();
    patchedTenderLot.identifier = '0<>' + tender.identifier;
    patchedTenderLot.recklessLow = tendereval.isConsideredAsAbnormallyLowTender;
    patchedTenderLot.motivationState = tendereval.admissionStatus.statusReason;
    let url = this.configuration.TENDERLOT_SERVICE_URL.replace('{tenderIdentifier}', tender.identifier);
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.patch<TenderLot>(
      url,
      patchedTenderLot
    ).pipe(
      catchError((error: any) => {
        console.error(error);
        this.uiService.showMessage(this.translateService.instant('TenderList.error.lotStatusError'));
        return throwError(error);
      }),
      finalize(() => this.waitService.cancelWaiting())
    ));
  }

  private patchTenderState(tenderId: string, state: TenderStateDTO): Observable<any> {
    let patchedTender = new TenderDTO();
    patchedTender.identifier = tenderId;
    patchedTender.state = state
    return this.plycaService.patch<TenderDTO>(
      this.configuration.TENDER_SERVICE_URL,
      patchedTender
    );
  }


  public getLotDescription(tenderLot: TenderLotV2DTO): string {
    const selectedProjectLot = this.project.breakdownLot.lots
      .find((projectLot: ProcurementProjectLotDTO) => projectLot.lotId === tenderLot.procurementProjectLot.lotId
        || projectLot.lotNumber === tenderLot.procurementProjectLot.lotNumber
      );
    return this.getProcurementProjectLotDescription(selectedProjectLot);
  }

  private getProcurementProjectLotDescription(projectLot: ProcurementProjectLotDTO): string {
    return (projectLot) ? projectLot.lotNumber + '-' + projectLot.description : '-';
  }

  /**
     * Metodos de edicion de lotes
     */
  public onLotEditInit(lot: TenderLotV2DTO): void {
    let editedLot = lodash.cloneDeep(lot);
    this.editingLots.set(editedLot.identifier, editedLot);
  }
  public onLotEditSave(lot: TenderLotV2DTO, tender: TenderV2DTO): void {
    let previousLotData = this.editingLots.get(lot.identifier)
    if (previousLotData) {
      const prevEval = previousLotData.tenderEvaluation;
      const currentEval = lot.tenderEvaluation;
      const patchTenderLot = prevEval.admissionStatus.statusCode !== currentEval.admissionStatus.statusCode ||
        prevEval.isConsideredAsAbnormallyLowTender !== currentEval.isConsideredAsAbnormallyLowTender ||
        prevEval.admissionStatus.statusReason !== currentEval.admissionStatus.statusReason;
      if (patchTenderLot) {
        if (!this.acceptTenderState &&
          this.enableRejectOnRegister && currentEval.admissionStatus.statusCode !== TenderAdmissionStatusCodeDTO.REFUSED) {
          this.uiService.showMessage(this.translateService.instant('TenderList.errors.statusOnRegister'));
        } else if ((currentEval.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.REFUSED
          || currentEval.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.EXCLUDED
          || currentEval.isConsideredAsAbnormallyLowTender === TriStateDTO.YES) && !currentEval.admissionStatus.statusReason) {
          this.uiService.showMessage(this.translateService.instant('TenderList.errors.reasonEmpty'));
        } else {
          this.editingLots.delete(lot.identifier);
          this.patchTenderLot(lot, tender);
          return;
        }
      }
      this.onLotEditCancel(lot);
    }
  }
  public onLotEditCancel(lot: TenderLotV2DTO): void {
    let previousLotData = this.editingLots.get(lot.identifier)
    lodash.assign(lot, previousLotData);
    this.editingLots.delete(lot.identifier);
  }

  private patchTenderLot(tenderLot: TenderLotV2DTO, tender: TenderV2DTO): void {
    this.waitService.startWaiting();
    this.subscribe(this.patchTenderLotObs(tenderLot, tender).pipe(
      catchError((error: any) => {
        console.error(error);
        this.uiService.showMessage(this.translateService.instant('TenderList.error.lotStatusError'));
        return throwError(error);
      }),
      switchMap(() => this.plycaService.get<TenderV2DTO>(this.configuration.TENDER_SERVICE_V2_URL, this.identifier)),
      tap((updatedTender: TenderV2DTO) => this.tender = updatedTender),
      finalize(() => this.waitService.cancelWaiting())
    )
    );
  }

  private patchTenderLotObs(tenderLot: TenderLotV2DTO, tender: TenderV2DTO): Observable<TenderLot> {
    const patchedTenderLot = new TenderLot();
    patchedTenderLot.identifier = tenderLot.procurementProjectLot.lotId.toString();
    patchedTenderLot.state = this.toTenderLotState(tenderLot.tenderEvaluation.admissionStatus.statusCode);
    patchedTenderLot.motivationState = tenderLot.tenderEvaluation.admissionStatus?.statusReason;
    patchedTenderLot.recklessLow = tenderLot.tenderEvaluation.isConsideredAsAbnormallyLowTender;
    let url = this.configuration.TENDERLOT_SERVICE_URL.replace('{tenderIdentifier}', tender.identifier);
    return this.plycaService.patch<TenderLot>(
      url,
      patchedTenderLot
    );
  }

  private toTenderLotState(statusCode: TenderAdmissionStatusCodeDTO): TenderLotState {
    let state: TenderLotState;
    switch (statusCode) {
      case TenderAdmissionStatusCodeDTO.ACEPTED: {
        state = TenderLotState.ADMITTED;
        break;
      } case TenderAdmissionStatusCodeDTO.REFUSED: {
        state = TenderLotState.REJECTED;
        break;
      } case TenderAdmissionStatusCodeDTO.EXCLUDED: {
        state = TenderLotState.EXCLUDED;
        break;
      } case TenderAdmissionStatusCodeDTO.INITIAL: {
        state = TenderLotState.INITIAL;
        break;
      }
    }
    return state;
  }

  public isValidSignature(signature: SignatureDTO): boolean {
    return SignatureDTO.isValidSignature(signature);
  }

  validateSignDocument(
    signature: SignatureDTO,
    fileItem: FileDetailsDTO
  ) {
    console.log('Método validateSignDocument');
    this.documentService.validateSignDocument(signature, fileItem);
  }

  public onTabOpen(e: any): void {
    this.selectedTab = e.index;
  }

  private excludeAllLots(): void {
    return this.patchStateAllLots(TenderAdmissionStatusCodeDTO.EXCLUDED);
  }

  private acceptAllLots(): void {
    return this.patchStateAllLots(TenderAdmissionStatusCodeDTO.ACEPTED);
  }

  private rejectAllLots(): void {
    return this.patchStateAllLots(TenderAdmissionStatusCodeDTO.REFUSED);
  }

  private patchStateAllLots(newstate: TenderAdmissionStatusCodeDTO): void {
    const requestObs = new Array<Observable<any>>();
    if (this.tender.tenderLots?.length > 0) {
      this.waitService.startWaiting();
      const errorLots = new Array<number>();
      this.tender.tenderLots.
        filter((lot: TenderLotV2DTO) => lot?.tenderEvaluation?.admissionStatus?.statusCode === TenderAdmissionStatusCodeDTO.INITIAL).
        forEach((lot: TenderLotV2DTO) => {
          // cambio el estado a una copia por no modificar
          const patchedLot = new TenderLotV2DTO();
          patchedLot.procurementProjectLot = lot.procurementProjectLot;
          const newTenderEvaluation = lodash.clone(lot.tenderEvaluation);
          newTenderEvaluation.admissionStatus.statusCode = newstate;
          patchedLot.tenderEvaluation = newTenderEvaluation;
          const internalObs = this.patchTenderLotObs(patchedLot, this.tender).pipe(
            catchError((error: any) => {
              console.error('Error al aceptar/rechazar lote ' + lot.procurementProjectLot?.lotNumber, error);
              errorLots.push(lot.procurementProjectLot?.lotNumber);
              return EMPTY;
            })
          );
          requestObs.push(internalObs);
        });
      this.subscribe(concat(...requestObs).pipe(
        finalize(() => {
          if (errorLots.length > 0) {
            this.uiService.showMessage(
              'Se produjo un error al aceptar los lotes con número: ' + errorLots.join(', ')
              , this.translationService.instant('General.error'));
          } else {
            // actualizar expediente
            this.subscribe(this.plycaService.get<TenderV2DTO>(this.configuration.TENDER_SERVICE_V2_URL, this.identifier).pipe(
              tap((updatedTender: TenderV2DTO) => this.tender = updatedTender),
              finalize(() => this.waitService.cancelWaiting())
            ));
          }
        })
      ));
    }
  }

}
